import useBoardStore from '../../store/boardStore';
import useBoardProtectionDialogStore from '../../store/boardProtectionDialogStore';
import BoardProtectionModal from './BoardProtectionModal';

// Monta o dialogo de senha do quadro no topo da arvore, fora do menu que o
// abre — ver o comentario de store/boardProtectionDialogStore.js: pelo
// clique-direito o BoardItemMenu desmonta ao fechar, e um dialogo montado
// dentro dele ia junto.
//
// O quadro vem da store de quadros quando ela o conhece (e dai o dialogo
// acompanha is_protected mudando por polling, sem reabrir); senao, usa o
// instantaneo que o menu passou.
export default function BoardProtectionHost() {
  const pending = useBoardProtectionDialogStore((s) => s.board);
  const close = useBoardProtectionDialogStore((s) => s.close);
  const boards = useBoardStore((s) => s.boards);
  const currentBoard = useBoardStore((s) => s.currentBoard);

  if (!pending) return null;
  const live = (currentBoard?.id === pending.id ? currentBoard : null)
    ?? boards.find((b) => b.id === pending.id)
    ?? pending;

  return <BoardProtectionModal board={live} onClose={close} />;
}
